import React, { useState } from 'react'
import { Link } from 'react-router-dom'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const Footer = (props) => {
    const [message, setMessage] = useState('');
    const [popup, setPopup] = useState({ show: false, message: '', type: '' });

    const SubmitHandler = async (e) => {
        e.preventDefault();

        try {
            let res = await fetch("https://formspree.io/f/mzzjgazb", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ message })
            });

            if (res.ok) {
                showPopup("Message sent successfully!", "success");
                setMessage("");
            } else {
                showPopup("Failed to send message. Try again!", "error");
            }
        } catch (err) {
            console.error(err);
            showPopup("Something went wrong. Please try later.", "error");
        }
    };

    const showPopup = (msg, type) => {
        setPopup({ show: true, message: msg, type });
        setTimeout(() => {
            setPopup({ show: false, message: '', type: '' });
        }, 3000);
    };

    return (
        <footer className={`wpo-site-footer ${props.ftClass}`}>
            <div className="wpo-upper-footer section-padding">
                <div className="container">
                    <div className="quote">
                        <span>Have an Idea?</span>
                        <h2>Let’s Make Something Amazing Together. </h2>

                        {/* ==== Popup ==== */}
                        {popup.show && (
                            <div className={`popup-message ${popup.type}`}>
                                <p>{popup.message}</p>
                            </div>
                        )}

                        {/* ==== Form ==== */}
                        <form onSubmit={SubmitHandler}>
                            <div className="input-field">
                                <input
                                    type="text"
                                    placeholder="Type your Message Here"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    required
                                />
                                <button type="submit">Get A Quote</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <ul>
                                <li>
                                    Copyright &copy; 2025 
                                    <Link onClick={ClickHandler} to="/"> Zohaib</Link>. All rights reserved.
                                </li>
                                <li>
                                    <ul>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-facebook"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-twitter-alt"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-linkedin"></i></Link></li>
                                        <li><Link onClick={ClickHandler} to="/"><i className="ti-instagram"></i></Link></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* ==== Popup CSS ==== */}
            <style jsx>{`
                .popup-message {
                    position: fixed;
                    top: 20px;
                    right: 20px;
                    background: #fff;
                    border-radius: 6px;
                    padding: 12px 18px;
                    font-weight: 500;
                    box-shadow: 0 4px 10px rgba(0,0,0,0.15);
                    z-index: 9999;
                    animation: fadeIn 0.3s ease-in-out;
                }
                .popup-message.success { border-left: 6px solid green; color: green; }
                .popup-message.error { border-left: 6px solid red; color: red; }
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(-10px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}</style>
        </footer>
    )
}

export default Footer;
